import { useState, useEffect } from 'react';
import { firestore } from '../firebase/config';
import { collection, query, where, getDocs, getDocsFromServer } from 'firebase/firestore';

function extrairNumero(nome) {
  const match = nome.match(/^(\d+)/);
  return match ? parseInt(match[1], 10) : 9999;
}

export function useLocalidades() {
  const [localidades, setLocalidades] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    async function fetchLocalidades() {
      setLoading(true);
      setError(null);
      try {
        const q = query(collection(firestore, 'localidades'), where('ativo', '==', true));
        let snapshot;
        try {
          // Tenta buscar direto do servidor para garantir dados atualizados
          snapshot = await getDocsFromServer(q);
        } catch {
          // Se offline, usa o cache local
          snapshot = await getDocs(q);
        }
        const docs = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        docs.sort((a, b) => extrairNumero(a.nome) - extrairNumero(b.nome));
        if (!cancelled) setLocalidades(docs);
      } catch (err) {
        console.error('useLocalidades: erro ao buscar localidades', err);
        if (!cancelled) setError('Nao foi possivel carregar as localidades.');
      } finally {
        if (!cancelled) setLoading(false);
      }
    }
    fetchLocalidades();
    return () => { cancelled = true; };
  }, []);

  return { localidades, loading, error };
}


export function useTodasLocalidades() {
  const [localidades, setLocalidades] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchLocalidades = async () => {
    setLoading(true);
    setError(null);
    try {
      const snapshot = await getDocs(collection(firestore, 'localidades'));
      const docs = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      docs.sort((a, b) => extrairNumero(a.nome) - extrairNumero(b.nome));
      setLocalidades(docs);
    } catch (err) {
      console.error('useTodasLocalidades: erro', err);
      setError('Nao foi possivel carregar as localidades.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchLocalidades(); }, []);

  return { localidades, loading, error, refetch: fetchLocalidades };
}
